import React from 'react'
import MetaContent from '../components/MetaContent'

export default function ProductUpdates() {
  const title = 'Product Updates'
  const description =
    'Stay up to date with the latest product updates from North Park Transportation.'

  return (
    <>
      <MetaContent title={title} description={description} />
      <section className="w-full">
        <iframe
          src="https://nopkproductupdates.framer.website/"
          title="North Park Transportation product updates"
          style={{ width: '100%', height: '100vh' }}
          className="block border-0"
          loading="lazy"
          allowFullScreen
        />
      </section>
    </>
  )
}
